import { FetchError } from "ofetch"
import * as Sentry from "@sentry/vue"

function isFetchErrorWithStatus(status: number, error: unknown): error is FetchError {
  return error instanceof FetchError && error.status === status
}

export const isUnauthorized = isFetchErrorWithStatus.bind(null, 401)

export const isNotFound = isFetchErrorWithStatus.bind(null, 404)

export const captureException: typeof Sentry.captureException = (...args) => {
  if (import.meta.client && typeof Sentry.captureException === "function") {
    return Sentry.captureException(...args)
  } else {
    console.error(...args)
    return ""
  }
}

export const captureMessage: typeof Sentry.captureMessage = (...args) => {
  if (import.meta.client && typeof Sentry.captureMessage === "function") {
    return Sentry.captureMessage(...args)
  } else {
    console.warn(...args)
    return ""
  }
}
